export default "__VITE_ASSET__BFA7oH20__"